import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { needsConsentChoice, setConsent, onOpenPreferences } from "@/lib/consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [fromPrefs, setFromPrefs] = useState(false);

  useEffect(() => {
    if (needsConsentChoice()) setVisible(true);
    return onOpenPreferences(() => {
      setFromPrefs(true);
      setVisible(true);
    });
  }, []);

  const choose = (marketing) => {
    setConsent(marketing);
    setVisible(false);
    if (fromPrefs) {
      setTimeout(() => window.location.reload(), 150);
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[2147483600] bg-white border border-border rounded-2xl shadow-xl p-6"
          role="dialog"
          aria-label="Informativa cookie"
          data-testid="cookie-banner"
        >
          <div className="flex items-start gap-4">
            <span className="flex-shrink-0 w-10 h-10 rounded-full bg-[#DDEBF2] flex items-center justify-center">
              <Cookie size={20} className="text-[#385244]" />
            </span>
            <div>
              <p className="font-serif-display text-lg text-[#15201A]">Rispettiamo la tua privacy</p>
              <p className="mt-2 text-sm leading-relaxed text-[#5C6B61]">
                Usiamo cookie tecnici necessari al funzionamento del sito e, solo con il tuo consenso,
                cookie di statistica e marketing (Google Analytics, Meta Pixel, Google Ads) per misurare
                il traffico e l'efficacia delle campagne pubblicitarie.
                Dettagli nella{" "}
                <Link to="/cookie-policy" className="underline text-[#385244]" data-testid="cookie-banner-policy-link">
                  cookie policy
                </Link>.
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <button
                  onClick={() => choose(true)}
                  className="inline-flex items-center rounded-full bg-[#385244] hover:bg-[#2B4035] text-white text-sm font-bold px-6 py-2.5 transition-colors duration-300 active:scale-95"
                  data-testid="cookie-accept-btn"
                >
                  Accetta tutti
                </button>
                <button
                  onClick={() => choose(false)}
                  className="inline-flex items-center rounded-full border border-[#385244] text-[#385244] hover:bg-[#385244]/5 text-sm font-bold px-6 py-2.5 transition-colors duration-300 active:scale-95"
                  data-testid="cookie-reject-btn"
                >
                  Rifiuta marketing
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
